import { create } from "zustand";
import { AVPromptSource, EventSource } from "@/common/buses";
import { FeedTypeEnum } from "@/common/api";

export interface IEventSource {
  name: EventSource;
  id?: string;
}

export enum SearchInitiator {
  TagLink = "Tag Link",
  SearchInput = "Search Input",
  Other = "Other",
}

interface IAnalyticsState {
  feedName: FeedTypeEnum | null;
  eventSource: IEventSource | null;
  searchInitiator: SearchInitiator | null;
  searchTag: string | null;
  gifContext: string | null;
  avPromptSource: AVPromptSource | null;
  setEventSource: (value: IEventSource | null) => void;
  setSearchInitiator: (value: SearchInitiator) => void;
  setSearchTag: (value: string | null) => void;
  setGifContext: (value: string | null) => void;
  setFeedName: (feed: FeedTypeEnum | null) => void;
  setAvPromptSource: (value: AVPromptSource | null) => void;
}

export const useAnalyticsStore = create<IAnalyticsState>((set) => ({
  feedName: null,
  eventSource: null,
  searchInitiator: null,
  searchTag: null,
  gifContext: null,
  avPromptSource: null,
  setEventSource: (value) => set(() => ({ eventSource: value })),
  setSearchInitiator: (value: SearchInitiator) => set(() => ({ searchInitiator: value })),
  setSearchTag: (value: string | null) => set(() => ({ searchTag: value })),
  setGifContext: (value: string | null) => set(() => ({ gifContext: value })),
  setFeedName: (value: FeedTypeEnum | null) => set(() => ({ feedName: value })),
  setAvPromptSource: (value: AVPromptSource | null) => set(() => ({ avPromptSource: value })),
}));
